import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const toggleOverpaymentArchive = api.injectEndpoints({
  endpoints: builder => ({
    toggleOverpaymentArchive: builder.mutation<Response, Request>({
      query: ({id}) => {
        return {
          method: 'POST',
          url: `overpayments/${id}/toggle-archive`,
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<{affected_row: ObjectId}>;

export const {useToggleOverpaymentArchiveMutation} = toggleOverpaymentArchive;
